import React, { ChangeEvent } from 'react'
import { ExpandMore, ExpandLess } from '@mui/icons-material'

import {
  CheckBox,
  TableContainerStyled,
  TableCellStyled,
  TableRowStyled,
  TableStyled,
  TableFooter
} from 'components'
import {
  BlockIcon,
  EditIcon,
  LinkIcon,
  // LockIcon,
  StatusIcon
} from 'components/Icons'
import { TypeHandleUser } from 'pages/Supplier/Users/Users'
import { COLORS, FORMAT, SPACING } from 'utils'
import { UsuarioFornecedor } from 'utils/types'

import { ITableContent } from '../../ValidationAccess'
import { UsuarioFornecedores } from 'utils/types'
import { TableBody, TableHead } from './TableAccess.styles'
import { Tooltip } from '@material-ui/core'

interface ITableAccess {
  tableData: ITableContent[]
  handleSelectAll: (e: ChangeEvent<HTMLInputElement>) => void
  handleUpdateCheckBox: (usuarioId: number) => void
  setSelectedUser: (user: UsuarioFornecedor, type: TypeHandleUser) => void
  setPage: React.Dispatch<React.SetStateAction<number>>
  page: number
  rowsPerPage: number
  setRowsPerPage: React.Dispatch<React.SetStateAction<number>>
  pageCount: number
  handleShowUserSuppliers: (_usuarioId: number) => void
}

export const TableAccess = ({
  tableData,
  setPage,
  page,
  setSelectedUser,
  handleSelectAll,
  handleUpdateCheckBox,
  pageCount,
  rowsPerPage,
  setRowsPerPage,
  handleShowUserSuppliers
}: ITableAccess) => {
  const handleChangePage = (newPage: number) => setPage(newPage)

  const handleChangeRowsPerPage = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleStatus = (status: string) => {
    if (
      status === 'Green' ||
      status === 'Aprovado' ||
      status === 'Liberado' ||
      status === 'L'
    )
      return 'Liberado'
    if (
      status === 'Yellow' ||
      status === 'Analisar' ||
      status === 'Analisando' ||
      status === 'PendenteDocumento' ||
      status === 'P'
    )
      return 'Aguardando validação'
    if (status === 'Red' || status === 'Recusado' || status === 'B')
      return 'Recusado'
    if (status === 'Red' || status === 'Expirado' || status === 'E')
      return 'Vencido'
    return 'Desativado'
  }

  // const getSuppliersInfo = (suppliersList: UsuarioFornecedores[], showSuppliers: boolean): React.ReactNode | string => {
  //   if (showSuppliers) {
  //     const suppliers = suppliersList?.map(supplier => <div>{supplier.nmFornecedor || '- - - -'} - {FORMAT.formatCdDocto(supplier?.cdDocto) || '- - - -'}<br /></div>)

  //     return <div>{suppliers}</div>
  //   }

  //   return `${suppliersList[0]?.nmFornecedor || '- - - -'} - ${FORMAT.formatCdDocto(suppliersList[0].cdDocto) || '- - - -'}`
  // }

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHead>
            <TableRowStyled>
              <TableCellStyled padding="checkbox" align="center">
                <CheckBox onChange={handleSelectAll} />
              </TableCellStyled>
              {/* <TableCellStyled>CNPJ/CPF/Passaporte</TableCellStyled> */}
              <TableCellStyled align="left">CPF/Passaporte</TableCellStyled>
              <TableCellStyled align="left">Colaborador</TableCellStyled>
              <TableCellStyled align="left">Contato</TableCellStyled>
              <TableCellStyled align="left">E-mail</TableCellStyled>
              <TableCellStyled align="left">Validade Acesso</TableCellStyled>
              <TableCellStyled width="116px" align="left">
                Perfil
              </TableCellStyled>
              <TableCellStyled align="left">Status</TableCellStyled>
              <TableCellStyled align="left">Ações</TableCellStyled>
            </TableRowStyled>
          </TableHead>
          <TableBody>
            {tableData?.length > 0 &&
              tableData.map(({ selected, content }) => (
                <TableRowStyled key={`${content.usuarioId}-row-table`}>
                  <TableCellStyled padding="checkbox" align="center">
                    {selected === null ? (
                      <CheckBox disabled />
                    ) : (
                      <CheckBox
                        checked={selected}
                        onChange={() => handleUpdateCheckBox(content.usuarioId)}
                      />
                    )}
                  </TableCellStyled>

                  <TableCellStyled align="left">
                    {FORMAT.documento(content.usuario.cdDocto)}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {content.usuario.nmUsuario}
                  </TableCellStyled>
                  <TableCellStyled>
                    {FORMAT.contatoInternacional(content.usuario.nuContato)}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {content.usuario.txEmail}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {FORMAT.formatDDMMYYYY(content.dtValidade)}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {content.usuario.perfilUsuario.txDenominacao}
                  </TableCellStyled>
                  <Tooltip
                    arrow
                    placement="left"
                    title={handleStatus(content.flSituacao)}
                  >
                    <TableCellStyled>
                      <StatusIcon
                        value={content.flSituacao}
                        colorIcon={COLORS.success}
                        marginLeft="auto"
                        marginRight="auto"
                      />
                    </TableCellStyled>
                  </Tooltip>
                  <TableCellStyled align="center">
                    <LinkIcon
                      disabled={content.flSituacao === 'D'}
                      onClick={() => setSelectedUser(content, 'contract')}
                    />
                    <EditIcon
                      disabled={content.flSituacao === 'D'}
                      onClick={() => setSelectedUser(content, 'edit')}
                      marginLeft={SPACING.spacing10}
                      marginRight={SPACING.spacing10}
                    />
                    <BlockIcon
                      // disabled={content.flSituacao === "B"}
                      colorIcon={COLORS.error}
                      onClick={() => setSelectedUser(content, 'block')}
                    />
                    {/* {content.flSituacao === "B" ? (
                    <LockIcon
                      onClick={() => setSelectedUser(content, "block")}
                    />
                  ) : (
                    <BlockIcon
                      colorIcon={COLORS.error}
                      onClick={() => setSelectedUser(content, "block")}
                    />
                  )} */}
                  </TableCellStyled>
                </TableRowStyled>
              ))}
          </TableBody>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page || 1}
        rows={tableData}
        totalItems={pageCount}
        rowsPerPage={rowsPerPage}
        typeFooter="online"
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  )
}
